import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response, Jsonp, URLSearchParams } from '@angular/http';
// import { User } from '../models/user';
import { AppConfig } from '../../app.config';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import { Subject } from 'rxjs/Subject';
@Injectable() 
export class PaymentDepositionService {
    constructor(private http: Http, private config: AppConfig, private _jsonp: Jsonp) { }
    getSlipImages(deposition_code, payment_mode) {
        return this.http.get(this.config.apiUrl + 'payment/get-slips?deposition_code=' + deposition_code
            + '&payment_mode=' + payment_mode, this.setHeaders()).map((response: Response) => response.json());
    }
    getPaymentDeposition(paymentDepositionCurrentPage: number, maxSize: any, filter: any, isExport: any) {
        return this.http.post(this.config.apiUrl + 'payment/payment-deposition?page=' + paymentDepositionCurrentPage + '&limit=' + maxSize + '&isExport=' + isExport, filter, this.setHeaders()).map((response: Response) => response.json());
    }
    setRevertSell(reqData) {
        return this.http.post(this.config.apiUrl + 'product/sales-return', reqData,
            this.setHeaders()).map((response: Response) => response.json());
    }
    getPaymentDetail(id: any) {
        return this.http.post(this.config.apiUrl + 'payment/find-by-id', { id: id }, this.setHeaders()).map((response: Response) => response.json());
    }
    conformPayment(id: any) {
        return this.http.post(this.config.apiUrl + 'payment/confirm', { id: id }, this.setHeaders()).map((response: Response) => response.json());
    }
    revertConformPayment(id: any, remark: any) {
        return this.http.post(this.config.apiUrl + 'payment/revert', { id: id, remark: remark }, this.setHeaders()).map((response: Response) => response.json());
    } setHeaders(params?: any) {
        // create authorization header with jwt token
        let token = localStorage.getItem('token');
        if (token) {
            // console.log('token >>>' + token);
            let headers = new Headers({ 'x-roamingse-token': token });
            if (params)
                return new RequestOptions({ headers: headers, search: params });
            else
                return new RequestOptions({ headers: headers });
        } else {
            return new RequestOptions({});
        }
    }
}



// WEBPACK FOOTER //
// /home/ec2-user/jenkins/workspace/new-roamingse/prod/roamingse-frontend/src/app/shared/services/payment-deposition.service.ts